import './Exchange.css';

export default function Exchange() {
  return (
    <section className="exchange">
      <div className="container">
        <div className="exchange__inner">
          <div className="exchange__text">
            <div className="exchange__tag">Temel Konsept</div>
            <h2 className="exchange__title">
              Notlar, ihtiyaçlara göre eşleşir
            </h2>
            <p className="exchange__desc">
              NoteSwapp, rastgele dosya paylaşımı yerine öğrencilerin aradığı ders notlarını doğru kişilerle buluşturmayı hedefler. Bir öğrenci not yüklediğinde, bu not ders, bölüm ve dönem bilgilerine göre uygun arama ilanlarıyla eşleşebilir. Talep gören bir not, birden fazla öğrencinin ihtiyacını karşılayabilir.
            </p>
            <ul className="exchange__list">
              <li>
                <span className="exchange__check">✓</span>
                Notlar, öğrencilerin arama ilanlarına göre uygun kişilerle eşleşir
              </li>
              <li>
                <span className="exchange__check">✓</span>
                Ders, bölüm ve dönem bilgileriyle düzenli bir not havuzu oluşturulur
              </li>
              <li>
                <span className="exchange__check">✓</span>
                Paylaşım öncesi AI destekli kalite ve uygunluk ön kontrolü yapılır
              </li>
            </ul>
          </div>

          <div className="exchange__visual">
            <div className="exchange__container">
              <div className="exchange__note exchange__note--blue">
                <div className="exchange__note-header">
                  <span className="exchange__note-label">Senin Notun</span>
                  <span className="exchange__note-badge">Yüklendi</span>
                </div>
                <div className="exchange__note-lines">
                  <div className="exchange__note-line exchange__note-line--full" />
                  <div className="exchange__note-line exchange__note-line--3q" />
                  <div className="exchange__note-line exchange__note-line--half" />
                  <div className="exchange__note-line exchange__note-line--2q" />
                </div>
                <div className="exchange__note-course">Calculus II</div>
              </div>

              <div className="exchange__center">
                <div className="exchange__icon-circle">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path d="M8 14h12" stroke="#5784E6" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M15 10l5 4-5 4" stroke="#5784E6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13 8l-5 6 5-6z" stroke="#FFB400" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13 8l-5 6" stroke="#FFB400" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M8 14l5 6" stroke="#FFB400" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className="exchange__flow-label">Adil takas</div>
              </div>

              <div className="exchange__note exchange__note--orange">
                <div className="exchange__note-header">
                  <span className="exchange__note-label">Diğer Not</span>
                  <span className="exchange__note-badge exchange__note-badge--green">Doğrulandı ✓</span>
                </div>
                <div className="exchange__note-lines">
                  <div className="exchange__note-line exchange__note-line--full" />
                  <div className="exchange__note-line exchange__note-line--2q" />
                  <div className="exchange__note-line exchange__note-line--3q" />
                  <div className="exchange__note-line exchange__note-line--half" />
                </div>
                <div className="exchange__note-course">Fizik I</div>
              </div>
            </div>

            <div className="exchange__caption">
              Dengeli bir değiş tokuş — bir not ver, bir not al.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
